<script>
  import { createEventDispatcher, getContext } from "svelte";
  import StaticPunchedCard from "./StaticPunchedCard.svelte";

  export let canvasWidth = "100%";
  export let forceCanvasWidth = false;
  export let reverseCaption = false;
  export let clickable = true;
  export let marginTop = false;
  const dispatch = createEventDispatcher();
  const encodingStore = getContext("encoding");
</script>

<div
  class="card-container noselect"
  class:reverseCaption
  class:marginTop
  class:forceCanvasWidth
  style={`--canvas-width: ${canvasWidth};`}
>
  <div class="caption">
    {reverseCaption ? "↗" : "↘"} The program input, simulated as a 1964 EBCDIC
    encoded punched card.
  </div>
  <div class="card">
    <StaticPunchedCard
      {clickable}
      on:click={(ev) => {
        if (clickable) {
          ev.preventDefault();
          dispatch("randomize");
        }
      }}
      encoding={$encodingStore}
    />
  </div>
</div>

<style>
  .card-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .marginTop {
    margin-top: 20px;
  }
  .card {
    margin-top: 0px;
  }
  .caption {
    font-size: 10px;
    margin-top: 0px;
  }
  .reverseCaption {
    flex-direction: column-reverse;
  }
  .card-container.forceCanvasWidth {
    width: calc(min(100%, var(--canvas-width)));
  }
  @media screen and (max-width: 720px) {
    /* make sure punched card doesn't extend past width of canvas on mobile  */
    .card-container {
      width: calc(min(100%, var(--canvas-width)));
      /* width: 100%; */
    }
  }
</style>
